import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import checkQuizShare from 'legacy/src/components/questionBank/QuizBuilder/utils/checkQuizShare';

import './styles.scss';

const DeleteQuizModal = ({
  onCancel,
  onDeleteQuiz,
  quizTitle,
  quizId,
  client,
}) => {
  const [isQuizShared, setIsQuizShared] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getIsQuizSharedStatus = async () => {
      setLoading(true);
      const isQuizSharedStatus = await checkQuizShare(client, quizId);
      setIsQuizShared(isQuizSharedStatus);
      setLoading(false);
    };
    getIsQuizSharedStatus();
  }, []);

  return (
    <ConfirmDialog
      size="tiny"
      title="Delete"
      onClose={onCancel}
      onSuccess={onDeleteQuiz}
      content={{
        btnPrimary: 'Delete',
        btnPrimaryType: 'danger',
        btnSecondary: 'Cancel',
      }}
    >
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Fragment>
          {isQuizShared && (
            <div className="px-6 py-4 bg-yellow-100 text-gray-900 text-14 flex gap-x-2.5">
              <div className="flex">
                <Icon
                  name="warning_triangle"
                  className="pt-1"
                  width={18}
                  height={18}
                />
              </div>
              <span>
                Quiz is Shared. Deleting the quiz will not affect copies already
                made by recipients of the shared quiz.
              </span>
            </div>
          )}
          <p>
            {`Are you sure you want to delete “${quizTitle}”? This action cannot be undone.`}
          </p>
        </Fragment>
      )}
    </ConfirmDialog>
  );
};

DeleteQuizModal.displayName = 'DeleteQuizModal';

DeleteQuizModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDeleteQuiz: PropTypes.func.isRequired,
  quizTitle: PropTypes.string.isRequired,
  quizId: PropTypes.number.isRequired,
};

export default DeleteQuizModal;
